import { SVGProps } from "react";

export function IconQuotationMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 54" {...props}>
      <path d="M0 54V40.696c8.268-1.566 9.208-4.109 9.208-12.913H0V2a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v22.652C28 42.848 18.604 52.63 0 54zm44 0V40.696c8.268-1.566 9.208-4.109 9.208-12.913H44V2a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v22.652C72 42.848 62.604 52.63 44 54z"></path>
    </svg>
  );
}
